import React, { useState, useEffect } from 'react'
import { SidebarLayout } from '@scuf/common'
import ChevronRight from '@mui/icons-material/ChevronRight'
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp'
import { Tooltip } from '@mui/material'

interface CollapsibleSidebarItemProps {
  content: string
  icon: any
  children?: any
  isActive?: boolean
  isParent?: boolean
  isSelected: boolean
  expand: boolean
  onClick?: () => void
}

const CollapsibleSidebarItem: React.FC<CollapsibleSidebarItemProps> = ({
  content,
  icon,
  children,
  isActive,
  onClick,
  isParent,
  isSelected,
  expand
}) => {
  const [isCollapsed, setIsCollapsed] = useState(true)

  useEffect(() => {
    setIsCollapsed(!expand)
  }, [expand])

  const handleToggle1 = (): void => {
    onClick?.()
  }
  const handleToggle2 = (e: any): void => {
    e.stopPropagation()
    setIsCollapsed(!isCollapsed)
  }
  const formatTextWithTooltip = (text: string): JSX.Element => {
    // istanbul ignore next
    if (text?.length > 12) {
      return (<Tooltip title={text}><span>{`${text.substring(0, 12)}...`}</span></Tooltip>)
    }
    return <span>{text !== '' ? text : 'NA'}</span>
  }
  return (
    <div className='hamburg-child'>
      {/* Main Item with collapse/expand icon */}
      <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={handleToggle1}>
        <SidebarLayout.Sidebar.Item
          content={<span className={isSelected ? 'menu-item-select-color' : ''}>{formatTextWithTooltip(content)}</span>}
          active={isActive ?? false}
          icon={icon}
          data-testid={`${content.toLowerCase().replace(/\s+/g, '-')}-icon`}
        />
        {/* Custom right icon for toggle */}
        {isCollapsed ? (<ChevronRight sx={{ marginLeft: 'auto', marginRight: '16px' }} onClick={handleToggle2}/>) : (<KeyboardArrowUp sx={{ marginLeft: 'auto', marginRight: '15px' }} onClick={handleToggle2} />) }
      </div>
      {/* Render children if expanded */}
      {!isCollapsed && <div className={`${(React.Children.count(children) > 5 ? 'item-extra-nodes' : '')}`} style={{ paddingLeft: (isParent === true) ? '34px' : '16px' }}>{children}</div>}
    </div>
  )
}

export default CollapsibleSidebarItem
